export default {
  tabPage: {
    padding: 10,
  },
  removeDate: {
    height: 30,
    padding: 0,
  },
  subRow: {
    display: 'flex',
    height: 30,
    verticalAlign: 'center',
    // justifyContent: 'center',
    alignItems: 'center',
  },
  addTask: {
    margin: 5,
  },
  taskButtons: {
    // position: 'relative',
    // right: 0,
    textAlign: 'right',
  },

  referenceCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 120,
  },
  customerCol: {
    width: 120,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dateCol: {
    width: 100,
  },
  descriptionCol: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  actionCol: {
    width: 80,
  },
  noData: {
    fontSize: 200,
    color: 'lightgrey',
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
};



// WEBPACK FOOTER //
// ./src/components/Jobs/FindJobDialog/styles.js